import { create } from 'zustand';

export type PaywallReason = 'feature_locked' | 'limit_reached' | 'subscription_expired';

export interface PaywallContext {
  reason: PaywallReason;
  /** Backend error code (FEATURE_NOT_AVAILABLE, SUBSCRIPTION_LIMIT, ...). */
  code: string;
  /** User-readable feature key (e.g. ai_forecasts) or resource (shops, products...). */
  feature?: string;
  resource?: string;
  current?: number;
  limit?: number;
  message?: string;
}

interface PaywallState {
  open: boolean;
  context: PaywallContext | null;
  openPaywall: (ctx: PaywallContext) => void;
  closePaywall: () => void;
}

export const usePaywallStore = create<PaywallState>((set) => ({
  open: false,
  context: null,
  openPaywall: (ctx) => set({ open: true, context: ctx }),
  closePaywall: () => set({ open: false, context: null }),
}));

/**
 * Imperative helper for non-React contexts (e.g. `lib/api.ts` interceptor).
 * Calling this from anywhere will surface the paywall modal in the UI.
 */
export function triggerPaywall(ctx: PaywallContext): void {
  usePaywallStore.getState().openPaywall(ctx);
}
